<template>
    <frontend-layout>
        <div class="grid h-full grid-cols-1 md:grid-cols-2">
            <div class="h-full bg-gray-50 p-4 lg:p-16">
                <div class="mx-auto max-w-xl lg:ml-auto lg:mr-0">
                    <div class="mb-8 text-center">
                        <div
                            class="mb-8 text-[32px] font-semibold leading-tight"
                        >
                            Create an organization
                        </div>
                        <div class="">
                            Organizations are for companies or groups ordering
                            more than 5 memberships. If you’re an individual
                            student, please visit our student pricing page.
                        </div>
                    </div>
                    <div class="mt-16 rounded bg-gray-300 p-8">
                        <div class="mb-4 font-semibold tracking-tight">
                            What you’ll get:
                        </div>
                        <ul class="flex flex-col gap-4">
                            <li class="flex items-center gap-2">
                                <img src="/assets/art/green_check_circle.png" />
                                Creating an organization is free
                            </li>
                            <li class="flex items-center gap-2">
                                <img src="/assets/art/green_check_circle.png" />
                                Receive bulk discounts when buying 5+
                                memberships
                            </li>
                            <li class="flex items-center gap-2">
                                <img src="/assets/art/green_check_circle.png" />
                                Invite your students and assign memberships to
                                them
                            </li>
                            <li class="flex items-center gap-2">
                                <img src="/assets/art/green_check_circle.png" />
                                Set goals for your students, and track their
                                progress
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="bg-white p-4 lg:p-16">
                <div class="mx-auto max-w-xl lg:ml-0 lg:mr-auto">
                    <form @submit.prevent="submit" class="flex flex-col gap-8">
                        <div class="">
                            <form-input
                                label="Organization name"
                                name="group_name"
                                v-model="form.group_name"
                            />
                        </div>
                        <div class="flex gap-8">
                            <div class="w-1/2">
                                <form-input
                                    label="First name"
                                    name="first_name"
                                    v-model="form.first_name"
                                />
                            </div>
                            <div class="w-1/2">
                                <form-input
                                    label="Last name"
                                    name="last_name"
                                    v-model="form.last_name"
                                />
                            </div>
                        </div>
                        <div class="">
                            <form-input
                                label="Email"
                                name="email"
                                v-model="form.email"
                            />
                        </div>
                        <div class="">
                            <form-input
                                label="Confirm email address"
                                name="email_confirmation"
                                v-model="form.email_confirmation"
                                hint="Please enter the owner of the organization (this account will have special privileges)"
                            />
                        </div>
                        <div class="">
                            <form-input
                                label="Password"
                                name="password"
                                type="password"
                                v-model="form.password"
                            />
                        </div>
                        <div class="">
                            <form-input
                                label="Confirm password"
                                name="password_confirmation"
                                type="password"
                                v-model="form.password_confirmation"
                            />
                        </div>
                        <div class="">
                            <form-checkbox
                                v-model="form.agreed_to_terms"
                                name="agreed_to_terms"
                            >
                                <div class="text-[15px] leading-7">
                                    I have read and agree to the EMTprep
                                    <Link
                                        class="link"
                                        href="/legal/terms-and-conditions"
                                        >Terms and Conditions
                                    </Link>
                                    and
                                    <Link
                                        class="link"
                                        href="/legal/membership-agreements"
                                        >Membership Agreement
                                    </Link>
                                </div>
                            </form-checkbox>
                        </div>
                        <div class="">
                            <button class="btn btn-primary">
                                Create Organization
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import FormInput from "@/Components/FormInput";
import FormCheckbox from "@/Components/FormCheckbox";

export default {
    name: "GroupRegisterForm",
    components: {
        FormCheckbox,
        FrontendLayout,
        FormInput,
    },
    data() {
        return {
            form: this.$inertia.form({
                group_name: "",
                first_name: "",
                last_name: "",
                email: "",
                email_confirmation: "",
                password: "",
                password_confirmation: "",
                agreed_to_terms: false,
            }),
        };
    },
    methods: {
        submit() {
            this.$inertia.post(
                route("frontend.groups.submit-register-form"),
                this.form
            );
        },
    },
};
</script>

<style scoped></style>
